import { DATE_GRANULARITY_DIMENSIONS } from '../../dimension/dimensions.model.js';
export const EXPORT_TOP_FLOP_ENABLED_DIMENSIONS = [
    'barcode',
    'barcode_anonymized',
    ...DATE_GRANULARITY_DIMENSIONS
];
//# sourceMappingURL=exportTopFlopEnabledDimensions.constant.js.map